module.exports = __webpack_public_path__ + "static/media/support.4b400ac6.svg";